import React from 'react';
import FieldSelect from '../FieldSelect';
import MapConfig from '../MapConfig';
import SeriesLabelsControl from './SeriesLabelsControl';
import { numericFields, categoricalFields } from '../charts';

// Chart options of the Chart node. Which controls appear depends on the
// chosen chart type; the values are the chart config the Viz component and
// the server-side exporter read.
export default function ChartConfigControl({ chartType, config, fields, onChange }) {
  const numeric = numericFields(fields);
  const categorical = categoricalFields(fields);
  const set = (patch) => onChange({ ...config, ...patch });

  if (chartType === 'map') {
    return (
      <MapConfig
        numeric={numeric}
        categorical={categorical}
        allFields={fields}
        config={config}
        setConfig={set}
      />
    );
  }
  if (chartType === 'scatter') {
    return (
      <>
        <FieldSelect
          label="X axis"
          options={numeric}
          value={config.x}
          onChange={(x) => set({ x })}
        />
        <FieldSelect
          label="Y axis"
          options={numeric}
          value={config.y}
          onChange={(y) => set({ y })}
        />
        <FieldSelect
          label="Color"
          options={categorical}
          value={config.color}
          onChange={(color) => set({ color })}
        />
      </>
    );
  }
  if (chartType === 'line') {
    return (
      <>
        <FieldSelect
          label="X axis"
          options={[...categorical, ...numeric]}
          value={config.x}
          onChange={(x) => set({ x })}
        />
        <FieldSelect
          label="Y axis"
          options={numeric}
          value={config.y}
          onChange={(y) => set({ y })}
        />
        <FieldSelect
          label="Series (one line per value)"
          options={categorical}
          value={config.seriesField}
          onChange={(seriesField) => set({ seriesField })}
        />
      </>
    );
  }
  if (chartType === 'bar' && config.stacked) {
    const distFields = (fields || []).filter((f) => f.key.startsWith('distribution__'));

    return (
      <>
        <StackedToggle config={config} set={set} />
        <FieldSelect
          label="X axis"
          options={categorical}
          value={config.x}
          onChange={(x) => set({ x })}
        />
        <FieldSelect
          label="Series"
          options={distFields}
          value={
            Array.isArray(config.series) ? config.series : config.series ? [config.series] : []
          }
          onChange={(s) => set({ series: s })}
          multiple
        />
        <SeriesLabelsControl
          keys={Array.isArray(config.series) ? config.series : []}
          fields={distFields}
          value={config.labels || {}}
          onChange={(labels) => set({ labels })}
        />
      </>
    );
  }
  if (chartType === 'table' || chartType === 'heatmap' || chartType === 'matrix') return null;
  return (
    <>
      {chartType === 'bar' && <StackedToggle config={config} set={set} />}
      <FieldSelect
        label="X axis"
        options={categorical}
        value={config.x}
        onChange={(x) => set({ x })}
      />
      <FieldSelect label="Y axis" options={numeric} value={config.y} onChange={(y) => set({ y })} />
      <FieldSelect
        label="Series"
        options={categorical}
        value={config.seriesField}
        onChange={(seriesField) => set({ seriesField })}
      />
    </>
  );
}

function StackedToggle({ config, set }) {
  return (
    <label className="viz-stacked">
      <input
        type="checkbox"
        checked={Boolean(config.stacked)}
        onChange={(e) => set({ stacked: e.target.checked })}
      />
      stacked groups
    </label>
  );
}
